var g = Object.defineProperty;
var a = Object.getOwnPropertySymbols;
var o = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
var n = (e, l, t) => l in e ? g(e, l, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[l] = t, s = (e, l) => {
  for (var t in l || (l = {}))
    o.call(l, t) && n(e, t, l[t]);
  if (a)
    for (var t of a(l))
      i.call(l, t) && n(e, t, l[t]);
  return e;
};
var w = (e, l) => {
  var t = {};
  for (var c in e)
    o.call(e, c) && l.indexOf(c) < 0 && (t[c] = e[c]);
  if (e != null && a)
    for (var c of a(e))
      l.indexOf(c) < 0 && i.call(e, c) && (t[c] = e[c]);
  return t;
};
import * as r from "react";
const d = (c) => {
  var m = c, {
    title: e,
    titleId: l
  } = m, t = w(m, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ r.createElement("svg", s({ height: 32, viewBox: "0 0 32 32", width: 32, xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", "aria-labelledby": l }, t), e ? /* @__PURE__ */ r.createElement("title", { id: l }, e) : null, /* @__PURE__ */ r.createElement("path", { d: "m16.0592049 0c2.7805979 0 5.4987733.824538 7.8107939 2.36935093 2.3120207 1.54479419 4.1140358 3.74052957 5.1781614 6.30948997 1.0641256 2.5688979 1.3425604 5.3957354.8001875 8.1229087-.5424354 2.7271733-1.8813716 5.2323362-3.8475358 7.1985628l-6.628134 6.6281341c-.8787315.8778567-2.0705772 1.3715535-3.3126611 1.3715535-1.2421464 0-2.4334297-.4931344-3.3121612-1.3709912l-6.63007108-6.6285714c-1.96616418-1.9662267-3.30526907-4.4715145-3.84768569-7.1986878-.54242287-2.7271733-.26395689-5.5540108.80016871-8.1229087 1.06410685-2.5689604 2.866122-4.76469578 5.17814262-6.30948997 2.31202064-1.54481293 5.03019604-2.36935093 7.81079474-2.36935093zm-.0000004 3.12426775c-2.1626806 0-4.2768101.6412872-6.07507615 1.84281809-1.79820355 1.20153089-3.19975006 2.90931813-4.02743107 4.90734984-.82768101 1.99809422-1.04425525 4.19670392-.62235414 6.31789422.39547372 1.9884988 1.33546703 3.8252021 2.71139524 5.3070993l.28096593.2915885 6.62925879 6.6276967c.2929313.2926189.6900258.4570179 1.1040537.4570179.414028 0 .8111224-.164399 1.1039913-.4570179l6.6275716-6.6275092c1.5292041-1.5293291 2.570585-3.4777474 2.9924862-5.5988753.4219011-2.1211903.2053268-4.3198-.6223542-6.31789422-.8276185-1.99803171-2.2292275-3.70581895-4.027431-4.90734984-1.7982036-1.20153089-3.9123956-1.84281809-6.0750762-1.84281809zm0 4.68640162c3.4509412 0 6.2485355 2.79759433 6.2485355 6.24853553s-2.7975943 6.2485355-6.2485355 6.2485355-6.24853549-2.7975943-6.24853549-6.2485355 2.79759429-6.24853553 6.24853549-6.24853553zm0 3.12426773c-1.7254706 0-3.1242677 1.3987972-3.1242677 3.1242678s1.3987971 3.1242677 3.1242677 3.1242677 3.1242678-1.3987971 3.1242678-3.1242677-1.3987972-3.1242678-3.1242678-3.1242678z" }));
};
export {
  d as default
};
